import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import AdminFunctionService from './adminFunction.service'

export const useAdminFunction = () => {
  const useGenerateCostSheetPdf = () => {
    return useMutation({
      mutationFn: AdminFunctionService.generateCostSheetPdf,
      onSuccess: (res) => {
        toast.info('Successfully Generate Cost Sheet PDF')
      },
    })
  }

  const useSignCommercialProposal = () => {
    return useMutation({
      mutationFn: AdminFunctionService.signProposal,
      onSuccess: (res) => {
        toast.info('Successfully Sign Commercial Proposal')
      },
    })
  }

  const useSignCostSheet = () => {
    return useMutation({
      mutationFn: AdminFunctionService.signCostSheet,
      onSuccess: (res) => {
        toast.info('Successfully Sign Cost Sheet')
      },
    })
  }
  const useBatchSendQuotationCompletedEmail = () => {
    return useMutation({
      mutationFn: AdminFunctionService.batchSendQuotationCompletedEmail,
      onSuccess: (res) => {
        toast.info('Successfully Batch Send Offer Quotation Completed Email')
      },
    })
  }

  return {
    useSignCommercialProposal,
    useGenerateCostSheetPdf,
    useSignCostSheet,
    useBatchSendQuotationCompletedEmail,
  }
}
